(function () {
  'use strict';

  angular
    .module('trackingDiscrepancy')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('trackingDiscrepancy', {
        url: '/tracking-discrepancy',
        views : {
          'trackingDiscrepancyView' : {
            templateUrl: 'tracking-discrepancy/views/tracking-discrepancy.tpl.html',
            controller: 'TrackingDiscrepancyCtrl',
            controllerAs: 'trackingDiscrepancy'
          }
        }

      });
  }
}());
